/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import * as zod from 'zod';

export const EntitiesAnnouncementCollectionListResponse = zod.object({
  "pagination": zod.object({
  "current_page": zod.int().describe('Current page number'),
  "items_per_page": zod.int().describe('Number of items per page'),
  "total_pages": zod.int().describe('Total number of pages')
}).describe('Pagination details').describe('Pagination details'),
  "results": zod.array(zod.object({
  "active": zod.boolean().describe('Active'),
  "content": zod.string().describe('Content'),
  "created_at": zod.iso.datetime({"offset":true}).describe('Created at'),
  "display_type": zod.enum(['banner', 'modal']).describe('Display type'),
  "ends_at": zod.iso.datetime({"offset":true}).describe('Ends at'),
  "id": zod.uuid().describe('ID'),
  "severity": zod.enum(['success', 'info', 'warning', 'error']).describe('Severity'),
  "starts_at": zod.iso.datetime({"offset":true}).describe('Starts at'),
  "title": zod.string().describe('Title'),
  "updated_at": zod.iso.datetime({"offset":true}).describe('Updated at')
}).describe('List of announcements')).describe('List of announcements'),
  "total_items": zod.int().describe('Total number of items')
})

export type EntitiesAnnouncementCollectionListResponse = zod.input<typeof EntitiesAnnouncementCollectionListResponse>;
export type EntitiesAnnouncementCollectionListResponseOutput = zod.output<typeof EntitiesAnnouncementCollectionListResponse>;
